import { AfterViewInit, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Utils } from 'src/modules/utils/shared/utils';
import { ButtonDefinition } from '../../models/button-definition.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';

@Component({
    selector: 'app-form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: []
})
export class FormDialogComponent implements AfterViewInit {

    app = inject(MainAppService);
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);

    @Input()
    form: FrontendFormDefinition = null;
    @Input()
    buttons: ButtonDefinition[] = [];

    @ViewChild('dialog') dialog: ElementRef;


    constructor() {
        this.form = this.config.data.form || "";
        this.buttons = this.config.data.buttons || [];
    }

    click(button: ButtonDefinition): void {
        if (button.isSuccess) {
            let errors = this.form.validate();
            if (errors != null) {
                this.app.messageService.add({ severity: "error", summary: "Ungültige Angaben", life: 5000, detail: Utils.toString(Utils.objectGetValues(errors)[0])});
                return;
            }
        }

        this.ref.close(button.id);
    }

    ngAfterViewInit(): void {
        GuiUtils.angularTimer(() =>  {
            this.dialog.nativeElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0]?.focus();
        });
    }

}
